export default __webpack_public_path__ + "6cf1a479d2ac8698b6b49b1ae0b9502d.png";